/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSyncValuesRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {GetSyncValuesResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const getSyncValues = (request:GetSyncValuesRequest, options?: CashRequestOptions) => post<GetSyncValuesRequest, GetSyncValuesResponse>("/2.0/cash/get-sync-values", request, {...options, rejectOnError: true })